/**
 * OEBAK-Teilnehmer
 * REST-Endpoints fuer Teilnehmer-Applikation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface HttpErrorResponseVO { 
    message?: string;
    stacktrace?: string;
    timestamp?: string;
    sessionId?: string;
    correlationId?: string;
    node?: string;
    url?: string;
}

